'use strict';

module.exports = {
  // STEPS & WALK
  AVERAGE_STEP_LENGTH: 0.74,
  AVERAGE_SPEED_WALK: 5,
  AVERAGE_DISTANCE_WALKING_PER_HOUR: 5000,

  // GENDERS
  GENDER_FEMALE: 'F',
  GENDER_MALE: 'M',
  GENDER_NON_BINARY: 'NB',
  GENDER_DO_NOT_DISCLOSE: 'DND',
};
